export const InitialIcon = () => {
  // return (
  //   <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <path
  //       d="M26.786.125H3.214C1.44.125 0 1.553 0 3.313v23.375c0 1.76 1.44 3.187 3.214 3.187h23.572c1.774 0 3.214-1.428 3.214-3.188V3.313c0-1.76-1.44-3.187-3.214-3.187ZM10.714 22.438c0 .587-.48 1.062-1.071 1.062H7.5a1.067 1.067 0 0 1-1.071-1.063v-8.5c0-.586.479-1.062 1.071-1.062h2.143c.592 0 1.071.476 1.071 1.063v8.5Zm6.429 0c0 .587-.48 1.062-1.072 1.062H13.93a1.067 1.067 0 0 1-1.072-1.063V7.563c0-.587.48-1.062 1.072-1.062h2.142c.592 0 1.072.475 1.072 1.063v14.875Zm6.428 0c0 .587-.479 1.062-1.071 1.062h-2.143a1.067 1.067 0 0 1-1.071-1.063v-4.25c0-.587.48-1.062 1.071-1.062H22.5c.592 0 1.071.476 1.071 1.063v4.25Z"
  //       fill="#FFFFFF"
  //     />
  //   </svg>
  // );

  return (
    <svg width="25" height="25" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 22C1.45 22 0.979167 21.8042 0.5875 21.4125C0.195833 21.0208 0 20.55 0 20V9C0 8.45 0.195833 7.97917 0.5875 7.5875C0.979167 7.19583 1.45 7 2 7H5V9H2V20H14V9H11V7H14C14.55 7 15.0208 7.19583 15.4125 7.5875C15.8042 7.97917 16 8.45 16 9V20C16 20.55 15.8042 21.0208 15.4125 21.4125C15.0208 21.8042 14.55 22 14 22H2ZM7 15V3.825L5.4 5.425L4 4L8 0L12 4L10.6 5.425L9 3.825V15H7Z" fill="white"/>
    </svg>
  )
};
